import { ArrowLeft, Check } from "lucide-react";
import type React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

const CURRENCIES = [
	{ code: "GBP", name: "British Pound" },
	{ code: "USD", name: "US Dollar" },
	{ code: "EUR", name: "Euro" },
];

const STORAGE_KEY = "preferredCurrency";

export const CurrencyPage: React.FC = () => {
	const [selected, setSelected] = useState<string>(
		() => localStorage.getItem(STORAGE_KEY) ?? "GBP",
	);
	const [saved, setSaved] = useState(false);

	const handleSave = () => {
		localStorage.setItem(STORAGE_KEY, selected);
		setSaved(true);
		setTimeout(() => setSaved(false), 3000);
	};

	return (
		<div className="min-h-screen bg-gradient-to-br from-pink-50 via-orange-50 to-yellow-50">
			<div className="max-w-2xl mx-auto sm:p-6 pt-6">
				<div className="bg-white/80 backdrop-blur-sm rounded-lg shadow-sm border border-gray-200 p-4 sm:p-6 lg:p-8">
					<div className="px-6 py-5 border-b border-gray-200">
						<div className="flex items-center mb-4">
							<Link
								to="/settings"
								className="mr-4 p-2 hover:bg-gray-100 rounded-lg transition-colors"
							>
								<ArrowLeft className="h-5 w-5 text-gray-600" />
							</Link>
							<div>
								<h2 className="text-2xl font-bold text-gray-900">Currency</h2>
								<p className="mt-1 text-sm text-gray-500">
									Choose the currency used for your payments
								</p>
							</div>
						</div>
					</div>

					<div className="px-6 py-6">
						{saved && (
							<div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg">
								<div className="flex items-center gap-2">
									<Check className="h-5 w-5 text-green-600" />
									<p className="text-sm text-green-700">Currency saved successfully.</p>
								</div>
							</div>
						)}

						<div className="space-y-4">
							<div>
								<label htmlFor="currency" className="block text-sm font-medium text-gray-700 mb-1">
									Currency
								</label>
								<select
									id="currency"
									value={selected}
									onChange={(e) => {
										setSelected(e.target.value);
										setSaved(false);
									}}
									className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 shadow-sm focus:border-orange-400 focus:outline-none focus:ring-2 focus:ring-orange-400/30"
								>
									{CURRENCIES.map((c) => (
										<option key={c.code} value={c.code}>
											{c.name} ({c.code})
										</option>
									))}
								</select>
							</div>

							<Button
								onClick={handleSave}
								className="bg-gradient-to-r from-orange-400 to-pink-400 hover:from-orange-500 hover:to-pink-500 text-white font-semibold transition-all duration-300 shadow-lg"
							>
								Save
							</Button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
